<template>
  <div class="flex h-full flex-col">
    <div class="isolate bg-white">
      <div class="absolute inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]">
        <svg
          class="relative left-[calc(50%-11rem)] -z-10 h-[21.1875rem] max-w-none -translate-x-1/2 rotate-[30deg] sm:left-[calc(50%-30rem)] sm:h-[42.375rem]"
          viewBox="0 0 1155 678"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="url(#45de2b6b-92d5-4d68-a6a0-9b9b2abad533)"
            fill-opacity=".3"
            d="M317.219 518.975L203.852 678 0 438.341l317.219 80.634 204.172-286.402c1.307 132.337 45.083 346.658 209.733 145.248C936.936 126.058 882.053-94.234 1031.02 41.331c119.18 108.451 130.68 295.337 121.53 375.223L855 299l21.173 362.054-558.954-142.079z"
          />
          <defs>
            <linearGradient
              id="45de2b6b-92d5-4d68-a6a0-9b9b2abad533"
              x1="1155.49"
              x2="-78.208"
              y1=".177"
              y2="474.645"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#3e4faa" />
              <stop offset="1" stop-color="#a13bdb" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      <div class="px-6 pt-6 lg:px-8">
        <div>
          <nav class="flex h-9 items-center justify-between" aria-label="Global">
            <div class="flex lg:min-w-0 lg:flex-1" aria-label="Global">
              <div class="-m-1.5 p-1.5">
                <span class="sr-only">MarketVue</span>
                <a href="https://marketvue.io">
                  <img class="h-10" src="../../assets/images/logo/Logo.svg" alt="logo" />
                </a>
              </div>
            </div>
          </nav>
        </div>
      </div>

      <main class="flex flex-1 flex-col">
        <div class="relative flex flex-1 flex-col px-6 lg:px-8">
          <div class="mx-auto flex max-w-[100em] flex-1 flex-col">
            <div class="grid flex-1 grid-cols-1 gap-12 lg:grid-cols-2">
              <!-- Marketing Content Side -->
              <div class="order-2 flex max-w-2xl flex-col justify-center pt-10 lg:order-1">
                <div class="mx-auto">
                  <h1 class="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                    Launch Powerful Direct Mail Campaigns in Minutes
                  </h1>
                  <p class="mt-6 text-lg leading-8 text-gray-600">
                    Effortless setup. Real results. Zero learning curve. Discover how marketers are turning postcards
                    into conversions with MarketVue.
                  </p>

                  <div class="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2">
                    <!-- Feature 1 -->
                    <div
                      class="rounded-xl bg-gradient-to-br from-indigo-50 to-purple-50 p-6 transition duration-300 hover:shadow-md"
                    >
                      <div class="flex items-center">
                        <div class="flex h-12 w-12 items-center justify-center rounded-full bg-white shadow-sm">
                          <svg
                            class="h-6 w-6 text-mv-primary"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42"
                            />
                          </svg>
                        </div>
                        <h3 class="ml-4 text-lg font-semibold text-gray-900">No Design Skills Needed</h3>
                      </div>
                      <p class="mt-3 text-base text-gray-600">
                        Our drag-and-drop editor makes campaign creation as easy as Canva.
                      </p>
                    </div>

                    <!-- Feature 2 -->
                    <div
                      class="rounded-xl bg-gradient-to-br from-indigo-50 to-purple-50 p-6 transition duration-300 hover:shadow-md"
                    >
                      <div class="flex items-center">
                        <div class="flex h-12 w-12 items-center justify-center rounded-full bg-white shadow-sm">
                          <svg
                            class="h-6 w-6 text-mv-primary"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M15 15l6-6m0 0l-6-6m6 6H9a6 6 0 000 12h3"
                            />
                          </svg>
                        </div>
                        <h3 class="ml-4 text-lg font-semibold text-gray-900">Seamless CRM Integration</h3>
                      </div>
                      <p class="mt-3 text-base text-gray-600">
                        Sync leads directly to HubSpot, Salesforce, or your favorite tools.
                      </p>
                    </div>

                    <!-- Feature 3 -->
                    <div
                      class="rounded-xl bg-gradient-to-br from-indigo-50 to-purple-50 p-6 transition duration-300 hover:shadow-md"
                    >
                      <div class="flex items-center">
                        <div class="flex h-12 w-12 items-center justify-center rounded-full bg-white shadow-sm">
                          <svg
                            class="h-6 w-6 text-mv-primary"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                            />
                          </svg>
                        </div>
                        <h3 class="ml-4 text-lg font-semibold text-gray-900">Call & QR Tracking</h3>
                      </div>
                      <p class="mt-3 text-base text-gray-600">
                        Know exactly who responds, when, and how—online or by phone.
                      </p>
                    </div>

                    <!-- Feature 4 -->
                    <div
                      class="rounded-xl bg-gradient-to-br from-indigo-50 to-purple-50 p-6 transition duration-300 hover:shadow-md"
                    >
                      <div class="flex items-center">
                        <div class="flex h-12 w-12 items-center justify-center rounded-full bg-white shadow-sm">
                          <svg
                            class="h-6 w-6 text-mv-primary"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"
                            />
                          </svg>
                        </div>
                        <h3 class="ml-4 text-lg font-semibold text-gray-900">Real-Time Analytics</h3>
                      </div>
                      <p class="mt-3 text-base text-gray-600">
                        Measure campaign ROI with delivery and response dashboards.
                      </p>
                    </div>

                    <!-- Feature 5 -->
                    <div
                      class="rounded-xl bg-gradient-to-br from-indigo-50 to-purple-50 p-6 transition duration-300 hover:shadow-md sm:col-span-2"
                    >
                      <div class="flex items-center">
                        <div class="flex h-12 w-12 items-center justify-center rounded-full bg-white shadow-sm">
                          <svg
                            class="h-6 w-6 text-mv-primary"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
                            />
                          </svg>
                        </div>
                        <h3 class="ml-4 text-lg font-semibold text-gray-900">Custom Landing Pages</h3>
                      </div>
                      <p class="mt-3 text-base text-gray-600">
                        Capture leads with custom pURLs and forms to maximize your campaign's conversion rate.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Form Side -->
              <div class="order-1 flex flex-col justify-center lg:order-2">
                <div class="relative mt-24 rounded-xl border bg-white p-12 pt-16 shadow-md">
                  <router-view />
                </div>
              </div>
            </div>
          </div>

          <!-- Trusted By Section -->
          <div class="mx-auto max-w-7xl px-6 py-4 lg:px-8">
            <div class="rounded-2xl bg-white">
              <div class="py-8">
                <h2 class="text-center text-lg font-semibold leading-8 text-gray-900">
                  Trusted by the world's most innovative teams
                </h2>
                <div
                  class="mx-auto mt-10 grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-10 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-5"
                >
                  <img
                    class="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
                    src="../../assets/images/dv.png"
                    alt="Datavue"
                    width="158"
                    height="48"
                  />
                  <img
                    class="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
                    src="../../assets/images/real-estate.png"
                    alt="Real Estate"
                    width="158"
                    height="48"
                  />
                  <img
                    class="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
                    src="../../assets/images/flavors-united.png"
                    alt="Flavors United"
                    width="158"
                    height="48"
                  />
                  <img
                    class="col-span-2 max-h-12 w-full object-contain sm:col-start-2 lg:col-span-1"
                    src="../../assets/images/modern-home.png"
                    alt="Modern Home"
                    width="158"
                    height="48"
                  />
                  <img
                    class="col-span-2 col-start-2 max-h-12 w-full object-contain sm:col-start-auto lg:col-span-1"
                    src="../../assets/images/brimston.png"
                    alt="Brimston"
                    width="158"
                    height="48"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="pointer-events-none absolute inset-x-0 -z-10 transform-gpu overflow-hidden blur-3xl">
            <svg
              class="relative left-[calc(50%+3rem)] h-[21.1875rem] max-w-none -translate-x-1/2 sm:left-[calc(50%+36rem)] sm:h-[42.375rem]"
              viewBox="0 0 1155 678"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="url(#ecb5b0c9-546c-4772-8c71-4d3f06d544bc)"
                fill-opacity=".3"
                d="M317.219 518.975L203.852 678 0 438.341l317.219 80.634 204.172-286.402c1.307 132.337 45.083 346.658 209.733 145.248C936.936 126.058 882.053-94.234 1031.02 41.331c119.18 108.451 130.68 295.337 121.53 375.223L855 299l21.173 362.054-558.954-142.079z"
              />
              <defs>
                <linearGradient
                  id="ecb5b0c9-546c-4772-8c71-4d3f06d544bc"
                  x1="1155.49"
                  x2="-78.208"
                  y1=".177"
                  y2="474.645"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#9089FC" />
                  <stop offset="1" stop-color="#FF80B5" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>
